import * as Sentry from '@sentry/browser';
import React, { Component, ErrorInfo, ReactNode } from 'react';
import { inProduction } from 'shared/helpers/utils';
import ErrorDisplay from './ErrorDisplay';

const errorsToIgnore = {
  ChunkLoadError: true
};

type ErrorBoundaryProps = {
  children: ReactNode;
};

class ErrorBoundary extends Component<
  ErrorBoundaryProps,
  { hasError: boolean }
> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    inProduction(() => {
      if (error.name in errorsToIgnore) {
        Sentry.withScope(scope => {
          scope.setExtras(errorInfo);
          Sentry.captureException(error);
        });
      }
    });
  }

  render() {
    const { children } = this.props;
    const { hasError } = this.state;
    if (hasError) {
      return <ErrorDisplay />;
    }

    return children;
  }
}

export default ErrorBoundary;
